import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'hooks';

function ProtectedRoute({ children }) {
	const { user, sessionChecked, handleMe } = useAuth();

	useEffect(() => {
		if (!sessionChecked) handleMe();
	}, [sessionChecked, handleMe]);

	if (!sessionChecked) return null;

	if (!user.username) return <Navigate to="/auth" replace />;

	return children;
}

export default ProtectedRoute;
